import eur from "@src/app/assets/currency/eur.svg"
import usd from "@src/app/assets/currency/usd_fiat.svg"
import usdt from "@src/app/assets/currency/usdt_trx.svg"
import { NetworkAll } from "@src/shared/api/generated"

export const conversionFormOptions = [
  { label: "USDT tron (TRC20)", network: NetworkAll.Tron, value: "USDT" },
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
]

export const conversionFormOptionsIcons: { [key: string]: string } = {
  EUR: eur,
  USD: usd,
  USDT: usdt,
}
